"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _locale_en = _interopRequireDefault(require("./locale_en"));

var _locale_fi = _interopRequireDefault(require("./locale_fi"));

var _locale_no = _interopRequireDefault(require("./locale_no"));

var _locale_sv = _interopRequireDefault(require("./locale_sv"));

var locales = {
  en: {
    name: 'English',
    translations: _locale_en["default"]
  },
  fi: {
    name: 'Finnish',
    translations: _locale_fi["default"]
  },
  no: {
    name: 'Norsk',
    translations: _locale_no["default"]
  },
  sv: {
    name: 'Svenska',
    translations: _locale_sv["default"]
  }
};
var _default = locales;
exports["default"] = _default;